import { maxPageWidthStyles } from '~/components/_common/MaxPageWidth/MaxPageWidth.styles';
import { maxPageWidthShellStyleSheet } from '~/components/_common/MaxPageWidth/maxPageWidthShell.styles';

const narrowViewportGutters = {
  '@media (max-width: 768px)': {
    paddingLeft: 16,
    paddingRight: 16,
  },
};

/**
 * Shared horizontal insets for patient workspace, pathway evaluation, and breadcrumb bars.
 * Desktop 24px / narrow 16px — matches Boron spacing used in polished `_` UI.
 */
export const routePageGutterStyleSheet = {
  breadcrumbBar: maxPageWidthShellStyleSheet.breadcrumbBar,
  horizontal: {
    boxSizing: 'border-box',
    paddingLeft: 24,
    paddingRight: 24,
    width: '100%',
    ...narrowViewportGutters,
  },
  maxWidthInset: {
    ...maxPageWidthStyles,
    boxSizing: 'border-box',
    paddingLeft: 24,
    paddingRight: 24,
    ...narrowViewportGutters,
  },
  actionBar: {
    alignItems: 'center',
    borderRadius: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    padding: '16px 24px',
  },
  insetBottomSection: {
    boxSizing: 'border-box',
    padding: '0 24px 24px',
    width: '100%',
    ...narrowViewportGutters,
  },
  insetHorizontalRow: {
    boxSizing: 'border-box',
    display: 'flex',
    gap: 16,
    justifyContent: 'space-between',
    padding: '0 24px',
    width: '100%',
    ...narrowViewportGutters,
  },
  fixedSubmitBar: {
    ...maxPageWidthStyles,
    boxSizing: 'border-box',
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    margin: '0 auto',
    padding: '16px 24px',
    width: '100%',
  },
} as const;
